/**
 * Soft Soft capability preview store — localhost preview only.
 * Production hosts must fail closed; Soft≠Live never paints as Live verified.
 */
import { isLocalHost } from "./pathseal.js";

const KEY = "croc-soft-machine-caps-v1";

function readAll() {
  try {
    const raw = sessionStorage.getItem(KEY);
    const obj = raw ? JSON.parse(raw) : {};
    return obj && typeof obj === "object" ? obj : {};
  } catch {
    return {};
  }
}

function writeAll(obj) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(obj || {}));
  } catch {
    /* ignore quota */
  }
}

export function softCapsGet(deviceId) {
  if (!isLocalHost()) return null;
  const did = String(deviceId || "").trim();
  if (!did) return null;
  const row = readAll()[did];
  if (!row || typeof row !== "object") return null;
  return {
    claimed: Array.isArray(row.claimed) ? row.claimed.map(String) : [],
    verified: Array.isArray(row.verified) ? row.verified.map(String) : [],
    deviceType: String(row.deviceType || row.device_type || "edge_ai_node").trim(),
    honesty: "soft_preview",
  };
}

export function softCapsPut(deviceId, row) {
  if (!isLocalHost()) return null;
  const did = String(deviceId || "").trim();
  if (!did) return null;
  const all = readAll();
  const next = {
    claimed: Array.isArray(row && row.claimed) ? row.claimed.map(String) : [],
    verified: Array.isArray(row && row.verified) ? row.verified.map(String) : [],
    deviceType: String((row && (row.deviceType || row.device_type)) || "edge_ai_node").trim(),
    updatedAt: new Date().toISOString(),
  };
  all[did] = next;
  writeAll(all);
  return { ...next, honesty: "soft_preview" };
}

export function softCapsItems() {
  if (!isLocalHost()) return [];
  const all = readAll();
  return Object.keys(all).map((device_id) => {
    const row = all[device_id] || {};
    return {
      device_id,
      device_type: String(row.deviceType || "edge_ai_node"),
      claimed: Array.isArray(row.claimed) ? row.claimed.map(String) : [],
      verified: Array.isArray(row.verified) ? row.verified.map(String) : [],
      honesty: "soft_preview",
    };
  });
}

export function isCapsRouteMissing(err) {
  const msg = String((err && err.message) || err || "");
  return /\b404\b|not found|503|disabled|capability_registry|unsupported|method not allowed/i.test(msg);
}
